"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function fsn(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.7492 10.659C20.9925 9.86854 19.4377 9.20703 16.5382 8.80128C15.624 8.67328 14.7061 8.57348 13.7857 8.50204C13.071 8.45929 12.3772 8.41654 11.7052 8.41654C10.5915 10.0815 9.54075 12.0893 8.616 14.502C7.60725 17.1495 6.70425 19.755 6.07425 22.125H5.88525C5.94825 19.584 6.36825 16.7018 7.23 13.7123C7.79775 11.7698 8.46975 10.0605 9.2265 8.56653C5.8215 8.92953 3.384 9.97579 2.25 11.4698C3.21675 9.09979 6.09525 7.09278 10.4872 6.38853C12.8197 2.90778 15.5723 1.34853 17.8628 2.03253C18.6607 2.26728 19.3335 2.77953 19.8802 3.50553C19.8165 3.46278 19.7535 3.42003 19.6702 3.39903C17.9887 2.71578 15.7192 3.69753 13.5127 6.13203H13.6177C18.5557 6.11103 21.0562 8.20354 21.75 10.659H21.7492ZM15.5715 13.8615C16.9162 13.8615 18.009 14.9933 18.009 16.3815C18.009 17.769 16.9162 18.9008 15.5715 18.9008C14.2267 18.9008 13.134 17.769 13.134 16.3808C13.134 14.9723 14.2267 13.8615 15.5715 13.8615Z", fill: color }));
}
exports["default"] = fsn;
//# sourceMappingURL=fsn.js.map